import { cn } from 'src/lib/tailwind-merge';
import type { ReactNode } from 'react';

interface TableProps {
  children: ReactNode;
  className?: string;
  minWidth?: string;
}

export const Table = ({ children, className, minWidth = '784px' }: TableProps) => {
  return (
    <table
      className={cn('w-full table-fixed border-separate border-spacing-0 border-b border-gray-100', className)}
      style={{ minWidth }}
    >
      {children}
    </table>
  );
};
